module.exports = __webpack_public_path__ + "img/yf3.f20c50fa.jpg";